import Vue from 'vue'
import Router from '../core'
import { version } from 'vue-router/package.json'

Vue.$app = Vue.$app || {}

Vue.$app.router = Router
Vue.$app.router.version = version
